import _ from 'lodash';
import React from 'react';
import TelemetryCardList from 'components/TelemetryCard/TelemetryCardList';
import { DateTime } from 'luxon';
import { sortLocale } from 'utils/string';

const parseTimestamp = (val) => {
  if (val) {
    return DateTime.fromMillis(val);
  }
  return undefined;
};

export const sortItems = (items) => {
  return sortLocale(_.uniqBy(items, 'displayName'), 'displayName');
};

export const getLastValueAssets = (signalValues) => {
  if (!signalValues.data?.signalSets) {
    return null;
  }
  const assetsSchemas = _.map(signalValues.data?.signalSets, signalSet => {
    return {
      assetDisplayName: signalSet.displayName,
      assetId: signalSet.assetId,
      schemas: signalSet.signals
    };
  });

  if (!signalValues.data?.data) {
    return null;
  }
  const values = _.map(signalValues.data?.data, signal => {
    const [time, value] = (!_.isEmpty(signal.data) ? _.last(signal.data) : [null, '-']);
    return {
      assetId: signal.assetId,
      name: signal.name,
      timestamp: parseTimestamp(time),
      value: value
    };
  });

  return _.map(assetsSchemas, asset => {
    const schemas = _.map(asset.schemas, schema => {
      const value = _.filter(values, value => value.assetId === asset.assetId && value.name === schema.name)[0];
      return {
        name: schema.name,
        displayName: schema.displayName,
        type: schema.type,
        unit: schema.unit,
        componentName: schema.componentName ?? null,
        value: {
          name: schema.name,
          componentName: schema.componentName ?? null,
          value: value?.value,
          timestamp: value?.timestamp
        }
      };
    });
    return {
      assetId: asset.assetId,
      assetDisplayName: asset.assetDisplayName,
      schemas
    };
  });
};

const LastValueTelemetryCard = ({ signalValues, isLoading }) => {
  const assetValues = getLastValueAssets(signalValues);
  if (assetValues == null) {
    return null;
  }

  return (<>{ _.map(assetValues, asset => {
    return (<TelemetryCardList
      key={asset.assetId}
      assetId={asset.assetId}
      header={asset.assetDisplayName}
      telemetryModelValues={sortItems(asset.schemas)}
      isLoading={isLoading}
      hideChart
    />);
  }) }</>);
};

export default LastValueTelemetryCard;
